import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { AffiliateDetailsModel } from "../../../../models/dashboard/marketplace/affiliateDetails";

const getAffiliateDetails = (id:string): Promise<AffiliateDetailsModel> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-marketplaces-details?Id=${id}`)
};

export default getAffiliateDetails;